export enum EImportCompletionCode {
  SUCCESS = 0,
  EXCEPTION = 1,
  CANCELED = 2,
  INVALID_FILE_STRUCTURE = 3
}
